import React, { useState, useContext, useEffect } from 'react';
import { VendorContext } from '../../context/VendorProvider';
import { debounce } from 'lodash';
import { WebsiteContext } from '../../context/WebsiteProvider';

const VendorSearch = ({
  selectedVendor,
  onVendorSelect,
  vendorLinkDisabled,
  excludeConsumers,
  excludeVendorId,
  excludeInactive,
}) => {
  const {
    getVendors,
    setVendorSearch,
    vendorSearchResults,
    setVendorSearchResults,
    setSelectedVendor,
  } = useContext(VendorContext);
  const { form, isVendorDropdownOpen, setVendorDropdownOpen } =
    useContext(WebsiteContext);

  const initialVendorValue =
    selectedVendor && selectedVendor.licensee ? selectedVendor.licensee : '';
  const [inputValue, setInputValue] = useState(initialVendorValue);

  useEffect(() => {
    setInputValue(form.vendor || '');
  }, [form.vendor]);

  useEffect(() => {
    if (selectedVendor && selectedVendor.licensee) {
      setInputValue(selectedVendor.licensee);
    } else {
      setInputValue('');
    }
  }, [selectedVendor]);

  const searchVendors = async (value) => {
    try {
      const allVendors = await getVendors();
      const filteredVendors = allVendors.filter(
        (vendor) =>
          (vendor.licensee.toLowerCase().includes(value.toLowerCase()) ||
            vendor.vendorCode.toLowerCase().includes(value.toLowerCase())) &&
          (!excludeConsumers || !vendor.isConsumer) &&
          (excludeInactive ? vendor.status : true) &&
          vendor.rowKey !== excludeVendorId
      );
      setVendorSearchResults(filteredVendors);
      setVendorDropdownOpen(true);
    } catch (error) {
      console.error('Failed to fetch vendor info', error);
      setVendorSearchResults([]);
      setVendorDropdownOpen(false);
    }
  };

  useEffect(() => {
    const debouncedSearchVendors = debounce((value) => {
      searchVendors(value, excludeInactive);
    }, 300);

    if (inputValue) {
      debouncedSearchVendors(inputValue);
    } else {
      setVendorSearchResults([]);
      setVendorDropdownOpen(false);
    }

    return () => {
      debouncedSearchVendors.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue, excludeInactive]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    setVendorSearch(newValue);
    setVendorDropdownOpen(true);
  };

  const handleVendorSelect = (vendor) => {
    setSelectedVendor(vendor);
    onVendorSelect(vendor);
    setInputValue(vendor.licensee);
    setVendorDropdownOpen(false);
  };

  return (
    <div>
      <input
        className="consumer-input"
        type="text"
        placeholder="Search by vendor name or vendor code..."
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setVendorDropdownOpen(true)}
        onBlur={() => setTimeout(() => setVendorDropdownOpen(false), 200)}
        autoComplete="off"
        readOnly={vendorLinkDisabled}
      />
      {isVendorDropdownOpen && vendorSearchResults.length > 0 && (
        <div className="absolute z-10 max-h-60 w-96 overflow-auto rounded border border-gray-200 bg-white dark:border-stone-700 dark:bg-stone-800 dark:text-gray-300">
          {vendorSearchResults.map((result) => (
            <div
              className="cursor-pointer p-2 hover:bg-gray-200 dark:hover:bg-stone-600"
              key={result.rowKey}
              onClick={() => handleVendorSelect(result)}
            >
              <span className="text-gray-600 dark:text-gray-300">
                {result.licensee}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VendorSearch;
